angular.module('unica_campaign.campaign_services')

.factory('CampaignEditService', function ($http, getBaseApiURL) {

	var campaignEditService = {};

	campaignEditService.update = function (campaignData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign/update/' + campaignData.id,
			data: campaignData
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign;
			}

		});
	};

	campaignEditService.updateFilter = function (campaignId, searchData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign/update-filter/' + campaignId,
			data: {
				filter: JSON.stringify( searchData )
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign;
			}

		});
	};

	return campaignEditService;
});